import React from "react";
import {
  TicketCreatePage,
  TicketCreatePageProps
} from "@tickets/TicketCreate/TicketCreatePage";
import { Location } from "../Location";

export class TicketCreateLocation extends Location<{}> {
  constructor(props?: TicketCreatePageProps) {
    super(props);
  }

  render() {
    return <TicketCreatePage {...this.params} />;
  }

  toURI() {
    return `/dashboard/ticket/create`;
  }
}
